import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Guard: never register SW in iframes or Lovable preview
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

if (isPreviewHost || isInIframe) {
  // Unregister any service worker that exists in preview to avoid stale
  // assets while developing inside Lovable's iframe.
  navigator.serviceWorker?.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}
// SW registration ahora vive en src/components/PwaUpdateBanner.tsx
// usando useRegisterSW() de virtual:pwa-register/react. Eso permite
// que React reaccione a `needRefresh` y muestre un banner cuando hay
// una nueva versión, en vez de updates silenciosos que pueden romper
// chunks en memoria.

createRoot(document.getElementById("root")!).render(<App />);
